import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['bordered', 'boxed']).isRequired,
  headerContent: PropTypes.node,
  headerTitle: PropTypes.string,
  theme: PropTypes.oneOf(['primary-light'])
};
function DataCard(_ref) {
  var children = _ref.children,
    _ref$headerContent = _ref.headerContent,
    headerContent = _ref$headerContent === void 0 ? null : _ref$headerContent,
    _ref$headerTitle = _ref.headerTitle,
    headerTitle = _ref$headerTitle === void 0 ? null : _ref$headerTitle,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? null : _ref$theme,
    variant = _ref.variant;
  var dataCardHeader = headerContent || headerTitle;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "data-card",
    "data-header": !!dataCardHeader,
    "data-testid": "data-card",
    "data-theme": theme,
    "data-variant": variant
  }, dataCardHeader && /*#__PURE__*/React__default.createElement("div", {
    className: "data-card-header",
    "data-testid": "data-card-header"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "h3"
  }, headerTitle), headerContent), /*#__PURE__*/React__default.createElement("div", {
    className: "data-card-content"
  }, children));
}
DataCard.propTypes = propTypes;

export { DataCard as default };
//# sourceMappingURL=DataCard.js.map
